import { useState } from 'react';
import WarehouseCommonApi from '../../../../../../API/warehouse/common-api';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../../constans';
import ReasonStockDebitPopUp from '../../../DebitPopUp';

const WarehouseStepper = ({ item = {}, skladName, save = () => { }, ...props }) => {
  const [value, setValue] = useState(0);

  const [showReasonDebit, setShowReasonDebit] = useState(false);

  const onChange = async (id, value, reason = '') => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: id, field: 'remains', value, reason, skladName } })
      .then((r) => {
        save(r.warehouseProduct);
        setValue(0);
      })
      .catch();
  };

  const clickAdd = async () => {
    if (value > 0) {
      onChange(item.id, value);
    }
  };

  const clickDebit = async (reason) => {
    if (value > 0) {
      onChange(item.id, 0 - value, reason); // передаем отрицательное число
    }
    setShowReasonDebit(false);
  };

  const reserved = item.sklad_data[skladName]?.shipment_reserved + item.sklad_data[skladName]?.hand_reserved;

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        disabled={item.sklad_data[skladName]?.stock - reserved < value}
        onClick={() => (value > 0 ? setShowReasonDebit(true) : {})}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '25px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        onClick={clickAdd}
        disabled={true}
      >
        <Icon src={plus} width="15px" />
      </Button>
      {showReasonDebit && (
        <ReasonStockDebitPopUp clickOk={(reason) => clickDebit(reason)} close={() => setShowReasonDebit(false)} />
      )}
    </Row>
  );
};

export default WarehouseStepper;
